const BarsSVG = () => {
  return (
    <svg
      width="90%" /* fits the width of the SVG to the container */
      height="90%" /* fits the height of the SVG to the container */
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 190 140">
      {/* <!-- Background --> */}
      <rect width="100%" height="100%" className="fill-neutralLight" rx="15" />

      {/* <!-- Grid lines --> */}
      <line
        x1="10"
        y1="10"
        x2="10"
        y2="130"
        className="stroke-neutralDark"
        stroke-width="1"
      />
      <line
        x1="10"
        y1="130"
        x2="180"
        y2="130"
        className="stroke-neutralDark"
        stroke-width="1"
      />

      {/* <!-- Bars with rounded top corners --> */}
      <path
        d="M30 130 v-40 a5 5 0 0 1 5 -5 h10 a5 5 0 0 1 5 5 v40 z"
        className="fill-neutralDark/50"
      />
      <path
        d="M60 130 v-60 a5 5 0 0 1 5 -5 h10 a5 5 0 0 1 5 5 v60 z"
        className="fill-neutralDark"
      />
      <path
        d="M90 130 v-50 a5 5 0 0 1 5 -5 h10 a5 5 0 0 1 5 5 v50 z"
        className="fill-neutralDark/50"
      />
      <path
        d="M120 130 v-80 a5 5 0 0 1 5 -5 h10 a5 5 0 0 1 5 5 v80 z"
        className="fill-neutralDark"
      />
      <path
        d="M150 130 v-110 a5 5 0 0 1 5 -5 h10 a5 5 0 0 1 5 5 v110 z"
        className="fill-neutralDark/50"
      />
    </svg>
  );
};

export default BarsSVG;
